<div class="pdf-container page-wraper" [ngClass]="isInline === true? 'inline-mode' : 'popup-mode'">
  <div class="container-controls">
    <div class="container-export"></div>
    <ng-container *ngIf="!isReadOnly">
      <ng-container *ngIf="viewMode === 'view' && !hideEditButton">
        <div class="container-commands" title="Click to open the file in Edit Mode">
          <div class="control-btn control-btn-edit" (click)="openForEdit()">
            <i class="fa-regular fa-pen grid-icon edit-icon"></i>
            <span class="control-text">Edit document</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="viewMode === 'edit' && !hideEditButton">
        <div class="container-commands" title="Exit From Edit Mode">
          <div class="control-btn control-btn-view" (click)="openForView()">
            <i class="fa-regular fa-pen grid-icon edit-icon"></i>
            <span class="control-text">Close edit mode</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="container-pdf" id='pdf_div'></div>
</div>
